module.exports = __webpack_public_path__ + "img/login-axp.9fb73ef0.png";